 <template>
 <div>

  <v-autocomplete
    _style="margin: 0px; padding-top: 10px; width: 100%; float: left"
    no-filter
    v-model="choosed"
    return-object
    clearable
    :search-input.sync="searchString"
    :items="items"
    color="primary"
    hide-no-data
    :item-text="itemText"
    :item-value="itemValue"
    :label="label"
    :loading="loading"
    :prepend-icon="!hideIcon ? 'mdi-database-search' : ''"
    @input="selected"
    @click:clear="clear"
    :disabled="disabled"
    :readonly="readonly"
    :rules="rules"
  >

    <!--template slot="item" slot-scope="{ item }">
      <v-list-item-content>
        <v-list-item-title>{{ item.name }} </v-list-item-title>
        <v-list-item-subtitle>{{ item.address }} - {{ item.cap }} - {{ item.city }} ({{ item.prov }})</v-list-item-subtitle>
      </v-list-item-content>
    </template-->
  </v-autocomplete>

 </div>
</template>
 
 <script>
let { getList, getDetail } = require("@/api/base_entity");

export default {
  props: {
    entity: {type: String, default: null},
    value: {type: Number, default: null},
    disabled: {type: Boolean, default: false},
    readonly: {type: Boolean, default: false},
    label: {type: String, default: ''},
    rowsPerPage: {type: Number, default: 30},
    rules: {type: Array},
    filters: {type: Function, default: function() { return {} }},
    hideIcon: {type: Boolean, default: false},
    itemText: {type: String},
    itemValue: {type: String}
  },
  data() {
    return {
      searchString: '',
      choosed: null,
      loading: false,
      items: [],
    }
  },
  watch: {
    value(id) {
      if(id) {
        getDetail(this.entity, {id}).then(ret =>  {
          // ret.codice_nome = ret.codice + ' - ' + ret.nome
          this.items = [ret]
          this.choosed = ret
        })
      } else {
        this.items = []
        this.choosed = null
      }
    },
    searchString(val) {

      // if (!oldVal) { return; }
      if (!val) {
        this.items = [];
        return;
      }
      // if(this.choosed) {
      //   if(val == this.choosed.codice + ' - ' + this.choosed.nome) {
      //     return
      //   }
      // }
      this.loading = true;
      
      // if(!isNaN(val) || !isNaN(val.replace('/', ''))  ) {
      // if(val.match(/\d+/g) != null) { // se continene anche solo un numero
      //   searchObj['codice'] = val+"%"
      // } else {
        // searchObj['name'] =  "%" + val + "%"
      // }
      const filters = typeof this.filters == 'function' ? this.filters(val) : {}
      
      getList(this.entity, filters, { rowsPerPage: this.rowsPerPage }).then(data => {
        this.items = data.data;
        this.loading = false;
      });
    },
  },
  methods: {
    resolvePath(object, path) {
      return path.split('.').reduce((o, p) => o?.[p], object)
    },
    selected() {

      const choosed2 =  this.choosed ?  this.resolvePath(this.choosed, this.itemValue) : null


     
      // const choosed =  this.choosed ?  this.choosed[this.itemValue] : null

       console.log(this.choosed, choosed2)


      this.$emit("input", choosed2);
      this.$emit("inputObj",  this.choosed);       
    },
    clear() {
      this.$emit("input", null);
      this.$emit("inputObj", null);     
    }
  }
};
</script>
 
 <style>
</style>